<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import useAppRouter from '../../../../Composables/useAppRouter.ts'
import { AlertType } from '../../../../Constants/AlertType.ts'
import Alert from '../UI/Alert.vue'
import ButtonAll from '../UI/Button/ButtonAll.vue'

// Composables
const { t, te } = useI18n()
const { getQueryParameter } = useAppRouter()

// Computed
const errorMessage = computed<string | null>(() => {
  const errorCode = getQueryParameter('e')
  if (errorCode === null) {
    return null
  }

  if (te(errorCode)) {
    return t(errorCode)
  }

  return t('2fa.errors.unknow_error')
})
</script>

<template>
  <h3>
    {{ t('2fa.form.title') }}
  </h3>

  <form action="/_connexion-mfa.php" method="POST">
    <Alert v-if="errorMessage" :type="AlertType.ERROR">
      {{ errorMessage }}
    </Alert>

    <div class="form-group">
      <input
        type="text"
        required
        id="2fa-code"
        name="code"
        :placeholder="t('2fa.form.fields.code.placeholder')"
        autocomplete="one-time-code"
        inputmode="numeric"
        maxlength="6"
        pattern="\d{6}"
        class="form-control form-control-lg"
        e2e-input="code"
      />
      <div class="invalid-feedback"></div>
    </div>

    <ButtonAll type="validation" width="full" margin="no" label="login.connexion" e2e-button="login" submit />
  </form>
</template>
